import React from 'react';
import { LegalDocumentPage } from '@/components/LegalDocumentPage';

/**
 * The Instructor Service Provision Agreement — still routed and titled
 * "Independent Contractor Agreement" — that the wallet setup wizard asks
 * instructors to accept (CKLSM-727 DOC-01).
 *
 * CKLSM-750 replaced the placeholder with Agreement 1.0, split out of the
 * bilingual source into one file per language.
 */
const IndependentContractorAgreement: React.FC = () => (
  <LegalDocumentPage
    documentType="independent-contractor-agreement"
    titleKey="independent_contractor_agreement.title"
  />
);

export default IndependentContractorAgreement;
